import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { Institution } from 'cb-model';

export interface TimetableRow {
  id: number;
  title: string;
  description: string | null;
  institution_id: number;
  created_at: string;
  updated_at: string;
  status: 'active' | 'finished';
}

export const Timetable: Entity<TimetableRow> = {
  id: 'Timetable',
  title: 'Timetable',
  service: 'main',
  rowLabel: (row: TimetableRow) => row.title,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.timetable',
  },
  security: [{ role: 'staff', action: 'all', access: 'all' }],
  listRowLink: '/admin/timetable/display/{key}',
  fields: {
    id: {
      seq: 5,
      type: FieldType.Integer,
      label: 'Id',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      autoIncrement: true,
    },
    title: {
      seq: 10,
      type: FieldType.Text,
      label: 'Title',
      mandatory: true,
      listColumn: true,
    },
    description: {
      seq: 15,
      type: FieldType.Text,
      label: 'Description',
    },
    institution_id: {
      seq: 20,
      type: FieldType.Reference,
      label: 'Institution',
      refEntity: Institution,
      mandatory: true,
    },
    created_at: {
      seq: 30,
      type: FieldType.Datetime,
      label: 'Created At',
      persistence: PersistenceType.BackEndManaged,
      listColumn: true,
    },
    updated_at: {
      seq: 35,
      type: FieldType.Datetime,
      label: 'Updated At',
      persistence: PersistenceType.BackEndManaged,
    },
    status: {
      seq: 45,
      type: FieldType.Options,
      label: 'Status',
      options: [
        { id: 'active', label: 'Active' },
        { id: 'finished', label: 'Finished' },
      ],
      mandatory: true,
      listColumn: true,
    },
  },
};
